var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusSuppression(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 9H8V8H11V9Z",
    fill: "#DB9A2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13H10V12H13V13Z",
    fill: "#DB9A2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11H9V10H12V11Z",
    fill: "#DB9A2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50169 9C6.49817 8.57811 6.38564 8.16429 6.17504 7.79871C5.96443 7.43312 5.66289 7.12819 5.29969 6.9135L9.00019 0.5L8.13519 0L4.34669 6.563C3.88174 6.45913 3.39817 6.4735 2.9402 6.60478C2.48224 6.73606 2.0645 6.98008 1.72519 7.3145C-0.146808 9.12 -0.00180808 13.341 0.00519192 13.52C0.0103605 13.6491 0.0653119 13.7712 0.158526 13.8607C0.25174 13.9502 0.375977 14.0001 0.505192 14H8.00069C8.10563 14 8.20791 13.967 8.29305 13.9056C8.37818 13.8443 8.44185 13.7577 8.47503 13.6581C8.50822 13.5586 8.50924 13.4511 8.47795 13.3509C8.44666 13.2507 8.38464 13.163 8.30069 13.1C6.53069 11.772 6.50169 9.027 6.50169 9ZM3.96519 7.4985C4.36538 7.5029 4.74846 7.66142 5.03474 7.94108C5.32102 8.22075 5.48845 8.60003 5.50219 9C5.50219 9.019 5.50319 9.104 5.51069 9.2345L2.56069 7.9225C2.75501 7.76226 2.97925 7.64226 3.22037 7.56947C3.46148 7.49668 3.71467 7.47256 3.96519 7.4985ZM5.72519 13C5.32554 12.5931 5.07079 12.066 5.00019 11.5H4.00019C4.036 12.0321 4.20222 12.5473 4.48419 13H3.37269C3.16707 12.3511 3.04196 11.6794 3.00019 11H2.00019C2.03244 11.6774 2.14403 12.3486 2.33269 13H1.00019C1.01569 12.082 1.14519 10.054 1.90169 8.7235L5.66819 10.3985C5.84916 11.3382 6.23497 12.2264 6.79819 13H5.72519Z",
    fill: "#DB9A2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSuppression);
export default __webpack_public_path__ + "static/media/status-suppression.52de4c2bd9905245ff99657a50c9bf0c.svg";
export { ForwardRef as ReactComponent };